<!-- stickyHeader -->
{#await promise}
  <DataTableSkeleton headers={['Marker', 'Type', 'Risk Allele', 'Gene', 'Trait', 'Panel']} rows={10} />
{:then data}
  <DataTable
    zebra
    sortable
    expandable={( data.length>0 &&data[0].snp!== NO_DATA )}
    title="Markers"
    description="Biomarkers of interest."
    headers={[
      { key: 'snp', value: 'Marker'},
      { key: 'type', value: 'Type'},
      { key: 'risk_allele', value: 'Risk Allele'},
      { key: 'gene', value: 'Gene' }, 
      { key: 'trait_name', value: 'Trait' }, 
      { key: 'panel_name', value: 'Panel' }, 
    ]}
    rows={data}
  >
    <Toolbar>
      <ToolbarContent>
        <ToolbarSearch />
        <ToolbarMenu>
          <ToolbarMenuItem primaryFocus>Check all</ToolbarMenuItem>
          <ToolbarMenuItem href="https://graphql.org/">
            API documentation
          </ToolbarMenuItem>
          <ToolbarMenuItem danger>Stop all</ToolbarMenuItem>
        </ToolbarMenu>
        <Button icon={Add16} on:click={e=>alert("\u03B2 3")}>Add Marker</Button>
      </ToolbarContent>
    </Toolbar>
  
    <span class="flex-wrap" slot="cell-header" let:header>
      {#if header.key === 'snp'}
        <OverflowMenu style="visibility:hidden;"></OverflowMenu>
        <div style="padding-left: 5px;">{header.value}</div>
      {:else if header.key === 'panel_name'}
        <!-- <div style="padding-left: 5px;">{header.value}</div> -->
        <div class="flex-wrap" on:click|stopPropagation>
          <PanelFilter selectedIds={panels} on:filterPanels={e=>filterPanels(e)}/>
        </div>
      {:else}{header.value}{/if}

    </span>

    <span class="flex-wrap" slot="cell" let:cell let:row>
      {#if cell.key === 'snp' && (data.length>0) && cell.value !== NO_DATA}
        <OverflowMenu>
          <OverflowMenuItem text="Review" on:click={e=>alert("\u03B2 4")} />

          <OverflowMenuItem>
            <Link
              inline
              href={`https://pubmed.ncbi.nlm.nih.gov/?term=${cell.value.toLowerCase()}`}
              target="_blank"
            >
              PubMed
              <Launch16 />
            </Link>
          </OverflowMenuItem>
          
          <OverflowMenuItem>
            <Link
              inline
              href={`https://www.ncbi.nlm.nih.gov/snp/${cell.value.toLowerCase()}`}
              target="_blank"
            >
              dbSNP
              <Launch16 />
            </Link>
          </OverflowMenuItem>

          <OverflowMenuItem>
            <Link
              inline
              href={`https://www.ncbi.nlm.nih.gov/CBBresearch/Lu/Demo/LitVar/#!?query=${cell.value.toLowerCase()}`}
              target="_blank"
            >
              LitVar
              <Launch16 />
            </Link>
          </OverflowMenuItem>

          <OverflowMenuItem>
            <Link
              inline
              href={`https://www.ebi.ac.uk/gwas/search?query=${cell.value.toLowerCase()}`}
              target="_blank"
            >
              GWAS
              <Launch16 />
            </Link>
          </OverflowMenuItem>
          <OverflowMenuItem danger text="Delete" on:click={e=>alert("\u03B2 4")} />
        </OverflowMenu>

        <Link style="padding-left: 5px;"
              inline
              href={`/marker/${row.id}/${cell.value}`}
        >{cell.value}</Link>
      {:else if cell.key === 'snp' && cell.value == NO_DATA}<div></div>
      {:else}{cell.value}{/if}
    </span>

    <div slot="expanded-row" let:row>
      <Expander markerId={row.snp}/>
    </div>
  
  </DataTable>
{/await}

<style>
.flex-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>

<script>
  import { get } from 'svelte/store'
  import auth from '../../helpers/auth.js'

  import Expander from './Expander.svelte'
  // import PanelFilter from './PanelFilter.svelte'
  import PanelFilter from './panel/Filter.svelte'

	// Firebase libraries
  import { Firestore } from '../../config/firebase'

	// Native Carbon Components
  import { DataTable, DataTableSkeleton } from "carbon-components-svelte" 
  import {
    Toolbar,
    ToolbarContent,
    ToolbarSearch,
    ToolbarMenu,
    ToolbarMenuItem,
    Button,
  } from "carbon-components-svelte"
  import {
    OverflowMenu,
    OverflowMenuItem,
    Link,
  } from "carbon-components-svelte"
  import Add16 from "carbon-icons-svelte/lib/Add16"
  import Launch16 from "carbon-icons-svelte/lib/Launch16"
  import Launch32 from "carbon-icons-svelte/lib/Launch32"

  const NO_DATA = 'NO DATA TO DISPLAY'

  const user = get(auth)

  let panels = []

  $: promise = getSnps(panels)

  const filterPanels = (e) => {
    if (e.detail != panels) {
      panels = e.detail
      // console.log('panels:',panels)
    }
  }

	async function getSnps(panels) {
		let snps = []
		try { 
      let snap
      if (panels.length > 0) {
      snap = await Firestore.collection('snps')
        .where("client_id", "==", user.clientID)
        .where("panel_id", "in", panels)
				.orderBy('client_code')
				.orderBy('panel_name')
        .orderBy('trait_name')
        .orderBy('gene')
				.orderBy('snp')
				.get()        
      } else {
      snap = await Firestore.collection('snps')
        .where("client_id", "==", user.clientID)
				.orderBy('client_code')
				.orderBy('panel_name')
        .orderBy('trait_name')
        .orderBy('gene')
				.orderBy('snp')
				.get()

      }

			snap.forEach( doc => {
				let data = doc.data()
				data.id = doc.id
				snps.push(data)
      })
      
      if (snap.size == 0) {
        snps = [
          {id:2,snp:NO_DATA,risk_allele:NO_DATA,type:'',gene:'',trait_name:'',panel_name:''},
        ]
      }
		} catch (error) {
			console.log("Error getting documents: ", error)
		}
		return snps
	}

</script>